import React from 'react'
import { Button, Col, Form, InputGroup, Offcanvas, Row } from 'react-bootstrap'
import { IconCircleX, IconPlus, IconTrash } from '@tabler/icons-react';
import TimezoneSelect, { allTimezones } from 'react-timezone-select';
import Select from "react-select"
import PhoneInput from 'react-phone-input-2';
import TagsInput from 'react-tagsinput';
import { components } from "react-select"
import { DateField, MultipleOpt, PhoneNumberInput, SelectOpt, Text, Time } from '../../../../pages/FieldComp';
import { Controller } from 'react-hook-form'
import useLocalStorageState from 'use-local-storage-state';
import { customStyles } from '../../../../Utils/helpers/commonhelper';
import validator from "validator"
import { toast } from 'sonner';

const MenuList = (props) => {
    const { canCreate, moduleType } = props?.selectProps
    return (
        <>
            <components.MenuList {...props}>
                {props.children}
                <div
                    style={{
                        padding: "10px",
                        borderTop: "1px solid #ddd",
                        textAlign: "center",
                        cursor: "pointer",
                        color: "#0d6efd",
                        fontWeight: 500,
                    }}
                    onClick={() => {
                        if (!canCreate && (moduleType === "company" || moduleType === "lead_source")) {
                            toast.warning("You are not authorized for this action!")
                            return
                        }
                        // trigger your modal open here
                        props.selectProps.onAddNew()
                    }}
                >
                    + Add New {props.selectProps.module}
                </div>
            </components.MenuList>
        </>
    )
}
export const ContactFormCommonOffcanvas = ({

    formTitle,

    show,
    setShow,
    handleClose,
    showRequired,
    setShowRequired,
    // handler from react hook form
    handleSubmit,
    register,
    control,
    errors,
    watch,
    setValue,

    // handler for actual form submit
    handleFormSubmit,
    duplicateEmailMessage,
    duplicatePhoneMessage,

    emails,
    handleAddContact,
    handleAddEmail,
    handleDeleteContact,
    handleDeleteEmail,
    handleEmailChange,
    handleContactChange,

    phoneOptions,
    emailOptions,
    emptyEmailIndices,
    emptyContactIndices,
    emailSectionRef,
    visibleToRef,
    leadSourceRef,
    contactSectionRef,

    company,
    contacts,
    leadOwner,
    country,
    states,
    city,
    teams,
    ungrouped,
    grouped,
    lead_source,

    validatePhoneNumber,
    companyShow,
    setCompanyShow,
    decision,
    setDecision,
    selectedTimezone,
    setSelectedTimezone,
    sourceShow,
    setSourceShow,

    tags,
    shouldShowField,
    allContacts,
    masterGrant,
    companyGrants,

    handleTagChange,

}) => {
    const [customer, setCustomer] = useLocalStorageState('customer')

    //option for add company
    const CustomOption1 = (props) => {
        if (props.data.value === "add_new") {
            return (
                <div
                    style={{
                        padding: "8px 10px",
                        cursor: "pointer",
                        color: "#7a3a5e",
                        display: "flex",
                        alignItems: "center",
                    }}
                    onClick={(e) => {
                        e.stopPropagation()
                        props.selectProps.onAddNew() // custom handler
                    }}
                >
                    <span style={{ marginRight: "5px", fontWeight: "bold" }}>＋</span>
                    Add Company
                </div>
            )
        }
        return <components.Option {...props} />
    }
    return (
        <Offcanvas
            placement="end"
            backdrop="static"
            enforceFocus={true}
            show={show}
            onHide={handleClose}
            style={{ width: "60%" }}
            className="createContactOffcanvas"
        >
            <Offcanvas.Header
                closeButton
                className="border-bottom border-dashed pt-3 "
            >
                <div className="d-flex align-items-center gap-2">
                    <div className="pt-0 ps-4">
                        <Offcanvas.Title
                            style={{ color: "#0791ff" }}
                            className="addEnquiryHead"
                        >
                            {formTitle}
                        </Offcanvas.Title>
                        <p
                            style={{ fontSize: "14px", color: "#b26792" }}
                            className=" text-secondary text-nowrap mb-0"
                        >
                            Create New Contact For Future
                        </p>
                    </div>
                </div>
                <div
                    className="d-flex justify-content-end align-items-center"
                    style={{ width: "70%", border: "none" }}
                >
                    <div type="button" className="form-check form-switch">
                        <input
                            className="form-check-input"
                            onChange={() => setShowRequired(prev => !prev)}
                            checked={showRequired}
                            type="checkbox"
                            role="switch"
                            id="switchCheckChecked"
                        />
                        <span
                            className="form-check-label text-secondary"
                            htmlFor="switchCheckChecked"
                            style={{
                                fontSize: "14px",
                            }}
                        >
                            Show & Hide Important Field
                        </span>
                    </div>
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body style={{ paddingTop: 0, paddingBottom: 0 }}>
                <div style={{ display: "flex", height: "100%" }}>
                    {/* main form */}
                    <Form
                        className="form-container"
                        onSubmit={handleSubmit(handleFormSubmit)}
                        encType="multipart/form-data"
                        style={{
                            margin: 0,
                            overflowY: "auto",
                            height: "100%",
                            paddingLeft: "0px",
                            paddingTop: "12px",
                            position: "relative",
                        }}
                    >
                        {/* basic information */}
                        <div className="offcanvasSections">
                            <h4 id="BasicInformation" className="offcanvasSecHeading">
                                Basic Information
                            </h4>
                            {/* firstname, lastname, salutation fields */}
                            <Row className="w-100 ms-0 mt-4">
                                <Col md={6} className="d-flex justify-content-between">
                                    <Form.Group
                                        className="mb-3 d-flex flex-column position-relative me-2 focus-z-index"
                                        controlId="formSalutation"
                                        style={{ width: "27%" }}
                                    >
                                        <Form.Label style={{ marginTop: "2px" }} className="">
                                            Salutation
                                        </Form.Label>
                                        <Form.Select
                                            name="salutation"
                                            id="salutation"
                                            {...register("salutation")}
                                            className="px-2 py-1 rounded-1 form-select-option w-100"
                                        >
                                            <option value="Mr.">Mr.</option>
                                            <option value="Mrs.">Mrs.</option>
                                            <option value="Miss">Miss</option>
                                        </Form.Select>
                                    </Form.Group>
                                    <Form.Group
                                        className="mb-3 position-relative focus-z-index"
                                        controlId="formFirstname"
                                        style={{ width: "80%" }}
                                    >
                                        <Form.Label>
                                            First Name <span className="text-danger">*</span>
                                        </Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                {...register("first_name", {
                                                    required: true,
                                                    setValueAs: (value) => value.trim(),
                                                })}
                                                placeholder="Enter Firstname"
                                            />
                                        </InputGroup>
                                        {errors.first_name && (
                                            <p
                                                style={{ fontSize: "12px" }}
                                                className="text-danger mt-1 "
                                            >
                                                {errors.first_name.message}
                                            </p>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group
                                        className="mb-3 position-relative focus-z-index"
                                        controlId="formLastName"
                                    >
                                        <Form.Label>
                                            Last Name
                                        </Form.Label>
                                        <InputGroup>
                                            <Form.Control
                                                type="text"
                                                {...register("last_name", {
                                                    required: true,
                                                    setValueAs: (value) => value.trim(),
                                                })}
                                                placeholder="Enter Lastname"
                                            />
                                        </InputGroup>
                                        {errors.last_name && (
                                            <p
                                                style={{ fontSize: "12px" }}
                                                className="text-danger mt-1 "
                                            >
                                                {errors.last_name.message}
                                            </p>
                                        )}
                                    </Form.Group>
                                </Col>
                                {!showRequired && (
                                    <Col md={6}>
                                        {/* leadOwner & report-to dropdowns */}
                                        <Form.Group
                                            className="mb-3 position-relative"
                                            controlId="formLastName"
                                        >
                                            <Controller
                                                name="owner_id"
                                                control={control}
                                                render={({ field }) => (
                                                    <div className=" ">
                                                        <Form.Label style={{ marginBottom: 1 }}>
                                                            Contact Owner
                                                        </Form.Label>
                                                        <Select
                                                            {...field}
                                                            className="input-box-select focus-z-index"
                                                            options={leadOwner?.map((lead) => ({
                                                                value: lead.leadId,
                                                                label: lead.leadName,
                                                            }))}
                                                            // value={
                                                            //   leadOwner.find(
                                                            //     (lead) => lead.leadId === field.value
                                                            //   )
                                                            //     ? {
                                                            //       value: field.value,
                                                            //       label: leadOwner.find(
                                                            //         (lead) =>
                                                            //           lead.leadId === field.value
                                                            //       )?.leadName,
                                                            //     }
                                                            //     : leadOwner[0]
                                                            //       ? {
                                                            //         value: leadOwner[0].leadId,
                                                            //         label: leadOwner[0].leadName,
                                                            //       }
                                                            //       : null
                                                            // }
                                                            value={
                                                                leadOwner.find((lead) => lead.leadId === (field.value || customer?.customer_details?.id))
                                                                    ? {
                                                                        value: field.value || customer?.customer_details?.id,
                                                                        label: leadOwner.find((lead) => lead.leadId === (field.value || customer?.customer_details?.id))?.leadName,
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(selectedOption) => {
                                                                field.onChange(
                                                                    selectedOption?.value ||
                                                                    customer.customer_details.id
                                                                )
                                                            }}
                                                            isClearable={true}
                                                            classNamePrefix="react-select"
                                                            styles={customStyles}
                                                        />
                                                    </div>
                                                )}
                                            />
                                        </Form.Group>
                                    </Col>
                                )}
                                {!showRequired && (
                                    <Col md={6}>
                                        {/* report to  */}
                                        <Form.Group
                                            className="mb-3 position-relative focus-z-index"
                                            controlId="formLastName"
                                        >
                                            <Form.Label>Report To</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    {...register("report_to")}
                                                    placeholder="Report To..."
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                )}
                                {/* visible to  */}
                                <Col md={6}>
                                    <div ref={visibleToRef}>
                                        <Form.Group
                                            className="mb-3 position-relative focus-z-index"
                                            controlId="formVisibleTo"
                                        >
                                            <Form.Label>
                                                Visible To <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Controller
                                                name="visible_to"
                                                control={control}
                                                defaultValue={[
                                                    {
                                                        id:
                                                            customer?.customer_details?.id?.toString() ||
                                                            "",
                                                        label:
                                                            (customer?.customer_details?.first_name ||
                                                                "") +
                                                            " " +
                                                            (customer?.customer_details?.last_name || ""),
                                                        type: "user",
                                                    },
                                                ]}
                                                render={({ field }) => {
                                                    const selectOptions = [
                                                        {
                                                            label: "Users",
                                                            options: leadOwner?.map((lead) => ({
                                                                value: lead.leadId,
                                                                label: lead.leadName,
                                                                type: "user",
                                                            })),
                                                        },
                                                        {
                                                            label: "Teams",
                                                            options: teams?.map((team) => ({
                                                                value: team.teamId.toString(),
                                                                label: team.teamName,
                                                                type: "team",
                                                            })),
                                                        },
                                                        {
                                                            label: "All",
                                                            options: [
                                                                { value: "0", label: "All", type: "all" },
                                                            ],
                                                        },
                                                    ]

                                                    const normalizeFieldArray = (raw) => {
                                                        if (!raw) return []
                                                        if (typeof raw === "string") {
                                                            const s = raw
                                                                .trim()
                                                                .replace(/^"+|"+$/g, "")
                                                                .toLowerCase()
                                                            if (s === "all") {
                                                                return [
                                                                    { id: "0", label: "All", type: "all" },
                                                                ]
                                                            }
                                                            try {
                                                                const parsed = JSON.parse(raw)
                                                                if (Array.isArray(parsed)) return parsed
                                                            } catch { }
                                                            return []
                                                        }
                                                        return Array.isArray(raw) ? raw : []
                                                    }

                                                    const rawArr = normalizeFieldArray(field.value)

                                                    const value = rawArr?.map((opt) => {
                                                        if (opt.type === "all" || opt.id === "0") {
                                                            return {
                                                                value: "0",
                                                                label: "All",
                                                                type: "all",
                                                            }
                                                        }
                                                        const match = selectOptions
                                                            .flatMap((g) => g.options)
                                                            .find(
                                                                (o) =>
                                                                    o.value === opt.id?.toString() &&
                                                                    o.type === opt.type
                                                            )
                                                        return (
                                                            match || {
                                                                value: opt.id?.toString(),
                                                                label: opt.label,
                                                                type: opt.type,
                                                            }
                                                        )
                                                    })

                                                    const dedupe = (arr) => {
                                                        const seen = new Set()
                                                        return arr.filter((x) => {
                                                            const k = `${x.value}-${x.type}`
                                                            if (seen.has(k)) return false
                                                            seen.add(k)
                                                            return true
                                                        })
                                                    }

                                                    return (
                                                        <Select
                                                            isMulti
                                                            options={selectOptions}
                                                            value={dedupe(value)}
                                                            onChange={(selected) => {
                                                                if (!selected || selected.length === 0) {
                                                                    field.onChange([])
                                                                    return
                                                                }

                                                                const pickedAll = selected.find(
                                                                    (s) => s.type === "all" || s.value === "0"
                                                                )
                                                                if (pickedAll) {
                                                                    field.onChange([
                                                                        {
                                                                            id: "0",
                                                                            label: "All",
                                                                            type: "all",
                                                                        },
                                                                    ])
                                                                    return
                                                                }

                                                                const mapped = selected?.map((s) => ({
                                                                    id: s.value.toString(),
                                                                    label: s.label,
                                                                    type: s.type,
                                                                }))

                                                                const uniq = []
                                                                const seen = new Set()
                                                                for (const m of mapped) {
                                                                    const k = `${m.id}-${m.type}`
                                                                    if (!seen.has(k)) {
                                                                        seen.add(k)
                                                                        uniq.push(m)
                                                                    }
                                                                }

                                                                field.onChange(uniq)
                                                            }}
                                                            placeholder="Visible To..."
                                                            classNamePrefix="react-select"
                                                            styles={customStyles}
                                                        />
                                                    )
                                                }}
                                            />
                                            {errors.visible_to && (
                                                <p
                                                    style={{ fontSize: "12px" }}
                                                    className="text-danger mt-1"
                                                >
                                                    {errors.visible_to.message}
                                                </p>
                                            )}
                                        </Form.Group>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <hr />
                        {/* communication */}
                        <div className="offcanvasSections">
                            <div>
                                <h4 id="Communication" className="offcanvasSecHeading">
                                    Communication
                                </h4>
                                {/* email, phone numbers , timezone fields */}
                                <div className="pt-3 d-flex flex-column  ">
                                    <Row className="w-100 ms-0">
                                        {/* email */}
                                        <Col md={6}>
                                            <div ref={emailSectionRef}>
                                                <Form.Group
                                                    className="mb-3 position-relative focus-z-index"
                                                    controlId="formEmail"
                                                >
                                                    {emails?.map((email, index) => {
                                                        const isDuplicate =
                                                            emails.filter(
                                                                (e) =>
                                                                    e.email === email.email && e.email !== ""
                                                            ).length > 1
                                                        const isEmailEmpty =
                                                            emptyEmailIndices?.includes(index)
                                                        return (
                                                            <div key={index}>
                                                                <div
                                                                    className="mb-2"
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 7,
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            width: "200px",
                                                                            position: "relative",
                                                                        }}
                                                                        className="focus-z-index"
                                                                    >
                                                                        <Form.Label>
                                                                            Email{" "}
                                                                            <span className="text-danger">*</span>
                                                                        </Form.Label>
                                                                        <Select
                                                                            id="formEmail"
                                                                            classNamePrefix="react-select"
                                                                            styles={customStyles}
                                                                            isSearchable={false}
                                                                            value={emailOptions.find(
                                                                                (opt) =>
                                                                                    opt.value ===
                                                                                    (email.email_type || "Office")
                                                                            )}
                                                                            options={emailOptions}
                                                                            onChange={(selectedOption) =>
                                                                                handleEmailChange(
                                                                                    "email_type",
                                                                                    selectedOption?.value || "Office",
                                                                                    index
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <InputGroup>
                                                                        <Form.Label>
                                                                            Email Address{" "}
                                                                            <span className="text-danger">*</span>
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            style={{
                                                                                height: "40px",
                                                                                border: "1px solid #c5c5c5",
                                                                            }}
                                                                            type="email"
                                                                            value={email.email}
                                                                            onChange={(e) =>
                                                                                handleEmailChange(
                                                                                    "email",
                                                                                    e.target.value,
                                                                                    index
                                                                                )
                                                                            }
                                                                            placeholder="ex: abc@gmail.com"
                                                                            className={
                                                                                isDuplicate ? "border-danger" : ""
                                                                            }
                                                                        />
                                                                    </InputGroup>
                                                                    {emails.length > 1 && (
                                                                        <button
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleDeleteEmail(index)
                                                                            }
                                                                            style={{
                                                                                width: "14px",
                                                                                height: "14px",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                border: "none",
                                                                                borderRadius: "50px",
                                                                                cursor: "pointer",
                                                                                marginLeft: "0px",
                                                                                padding: 0,
                                                                                background: "none",
                                                                            }}
                                                                        >
                                                                            <IconTrash
                                                                                stroke={2}
                                                                                style={{ stroke: "red" }}
                                                                                className="w-3 h-3"
                                                                            ></IconTrash>
                                                                        </button>
                                                                    )}
                                                                </div>
                                                                {isDuplicate && (
                                                                    <p
                                                                        className="mt-1 text-danger"
                                                                        style={{
                                                                            fontSize: "12px",
                                                                            marginTop: "2px",
                                                                            marginBottom: "8px",
                                                                        }}
                                                                    >
                                                                        Duplicate email
                                                                    </p>
                                                                )}
                                                                {isEmailEmpty && (
                                                                    <p
                                                                        style={{ fontSize: "12px" }}
                                                                        className="text-danger mt-1"
                                                                    >
                                                                        Email is Required !
                                                                    </p>
                                                                )}
                                                                {email.email &&
                                                                    email.email?.trim() !== "" &&
                                                                    !validator.isEmail(email.email) && (
                                                                        <p
                                                                            className="text-danger"
                                                                            style={{ fontSize: "12px" }}
                                                                        >
                                                                            Invalid email format
                                                                        </p>
                                                                    )}
                                                                {duplicateEmailMessage && index === 0 && (
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            fontSize: "12px",
                                                                            gap: 2,
                                                                            paddingTop: "4px",
                                                                            marginBottom: "10px",
                                                                        }}
                                                                        className="text-danger"
                                                                    >
                                                                        <IconCircleX
                                                                            stroke={2}
                                                                            style={{
                                                                                width: "14px",
                                                                                height: "14px",
                                                                            }}
                                                                        />
                                                                        {duplicateEmailMessage}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    })}
                                                </Form.Group>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={handleAddEmail}
                                                style={{
                                                    fontSize: "13px",
                                                    border: 0,
                                                    color: "#777",
                                                    background: "none",
                                                }}
                                            >
                                                Add Email
                                                <IconPlus
                                                    stroke={2}
                                                    style={{
                                                        width: "15px",
                                                        height: "15px",
                                                        border: "none",
                                                    }}
                                                ></IconPlus>
                                            </button>
                                        </Col>
                                        {/* phone nos. */}
                                        <Col md={6}>
                                            <div ref={contactSectionRef}>
                                                <Form.Group
                                                    className="mb-3 position-relative focus-z-index"
                                                    controlId="formContact"
                                                >
                                                    {contacts?.map((contact, index) => {
                                                        const isDuplicate =
                                                            contacts.filter(
                                                                (c) =>
                                                                    c.phone === contact.phone &&
                                                                    c.countryName === contact.countryName &&
                                                                    contact.phone !== ""
                                                            ).length > 1
                                                        const isContactEmpty =
                                                            emptyContactIndices?.includes(index)
                                                        return (
                                                            <div key={index}>
                                                                <div
                                                                    className="mb-2"
                                                                    style={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 7,
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            width: "200px",
                                                                            position: "relative",
                                                                        }}
                                                                        className="focus-z-index"
                                                                    >
                                                                        <Form.Label>
                                                                            Contact{" "}
                                                                            <span className="text-danger">*</span>
                                                                        </Form.Label>
                                                                        <Select
                                                                            name="contact"
                                                                            id="formContact"
                                                                            classNamePrefix="react-select"
                                                                            styles={customStyles}
                                                                            value={phoneOptions.find(
                                                                                (opt) =>
                                                                                    opt.value ===
                                                                                    (contact.phone_type || "Mobile")
                                                                            )}
                                                                            options={phoneOptions}
                                                                            onChange={(selectedOption) =>
                                                                                handleContactChange(
                                                                                    "phone_type",
                                                                                    selectedOption?.value || "Mobile",
                                                                                    index
                                                                                )
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <InputGroup>
                                                                        <Form.Label>
                                                                            Mobile Number{" "}
                                                                            <span className="text-danger">*</span>
                                                                        </Form.Label>
                                                                        <PhoneInput
                                                                            country={"in"}
                                                                            countryCodeEditable={false}
                                                                            buttonStyle={{ border: "none" }}
                                                                            inputStyle={{
                                                                                width: "320px",
                                                                                height: "40px",
                                                                                border: "none"
                                                                            }}
                                                                            containerStyle={{
                                                                                border: `${isDuplicate
                                                                                    ? "1px solid #dc3545"
                                                                                    : "1px solid #c5c5c5"
                                                                                    }`,
                                                                                borderRadius: "5px",
                                                                            }}
                                                                            value={""}
                                                                            onChange={(
                                                                                value,
                                                                                country,
                                                                                e,
                                                                                rawInputValue
                                                                            ) => {
                                                                                const countryCode = country.dialCode
                                                                                const countryName =
                                                                                    country.countryCode
                                                                                const rawNum =
                                                                                    rawInputValue?.replace(
                                                                                        /\D/g,
                                                                                        ""
                                                                                    ) || ""
                                                                                handleContactChange(
                                                                                    "phone",
                                                                                    rawNum.slice(countryCode.length),
                                                                                    index,
                                                                                    {
                                                                                        country_code: countryCode,
                                                                                        countryName: countryName,
                                                                                    }
                                                                                )
                                                                            }}
                                                                            classNamePrefix="react-select"
                                                                            styles={customStyles}
                                                                        />
                                                                    </InputGroup>
                                                                    {contacts.length > 1 && (
                                                                        <button
                                                                            type="button"
                                                                            onClick={() =>
                                                                                handleDeleteContact(index)
                                                                            }
                                                                            style={{
                                                                                width: "14px",
                                                                                height: "14px",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                border: "none",
                                                                                borderRadius: "50px",
                                                                                cursor: "pointer",
                                                                                marginLeft: "0px",
                                                                                padding: 0,
                                                                                background: "none",
                                                                            }}
                                                                        >
                                                                            <IconTrash
                                                                                stroke={2}
                                                                                style={{
                                                                                    width: "12px",
                                                                                    height: "12px",
                                                                                    stroke: "red",
                                                                                }}
                                                                            ></IconTrash>
                                                                        </button>
                                                                    )}
                                                                </div>
                                                                {isDuplicate && (
                                                                    <p
                                                                        className="text-danger"
                                                                        style={{
                                                                            fontSize: "12px",
                                                                            marginTop: "2px",
                                                                            marginBottom: "8px",
                                                                        }}
                                                                    >
                                                                        Duplicate Contact !
                                                                    </p>
                                                                )}
                                                                {isContactEmpty && (
                                                                    <p
                                                                        style={{ fontSize: "12px" }}
                                                                        className="mt-1 text-danger"
                                                                    >
                                                                        Contact is Required !
                                                                    </p>
                                                                )}
                                                                {contact.phone &&
                                                                    contact.phone?.trim() !== "" &&
                                                                    !validatePhoneNumber(
                                                                        contact.phone,
                                                                        contact?.countryName
                                                                    ) && (
                                                                        <p
                                                                            style={{ fontSize: "12px" }}
                                                                            className="mt-1 text-danger"
                                                                        >
                                                                            Phone is Invalid!
                                                                        </p>
                                                                    )}
                                                                {duplicatePhoneMessage && index === 0 && (
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            fontSize: "12px",
                                                                            gap: 2,
                                                                            paddingTop: "4px",
                                                                            marginBottom: "10px",
                                                                        }}
                                                                        className="text-danger"
                                                                    >
                                                                        <IconCircleX
                                                                            stroke={2}
                                                                            style={{
                                                                                width: "10px",
                                                                                height: "10px",
                                                                            }}
                                                                        />
                                                                        {duplicatePhoneMessage}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )
                                                    })}
                                                </Form.Group>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={handleAddContact}
                                                style={{
                                                    fontSize: "13px",
                                                    border: 0,
                                                    color: "#777",
                                                    background: "none",
                                                }}
                                            >
                                                Add Contact
                                                <IconPlus
                                                    stroke={2}
                                                    style={{
                                                        width: "15px",
                                                        height: "15px",
                                                        border: "none",
                                                    }}
                                                ></IconPlus>
                                            </button>
                                        </Col>
                                        {!showRequired && <Col md={12} className="mt-3">
                                            <Form.Group
                                                className="mb-3 position-relative focus-z-index"
                                                controlId="formTimezone"
                                            >
                                                <div className="d-flex flex-column gap-1">
                                                    <Form.Label style={{ marginBottom: 1 }}>
                                                        Select Timezone{" "}
                                                    </Form.Label>
                                                    <div style={{ fontSize: "14px" }}>
                                                        <TimezoneSelect
                                                            timezones={{
                                                                ...allTimezones,
                                                                "America/Lima": "Pittsburgh",
                                                                "Europe/Berlin": "Frankfurt",
                                                            }}
                                                            value={selectedTimezone}
                                                            onChange={setSelectedTimezone}
                                                            styles={customStyles}
                                                            classNamePrefix="react-select"
                                                        />
                                                    </div>
                                                </div>
                                            </Form.Group>
                                        </Col>}
                                    </Row>
                                </div>
                            </div>
                        </div>

                        {!showRequired && <>
                            <hr />
                            <div className="offcanvasSections">
                                <h4 id="Location" className="offcanvasSecHeading">
                                    Location
                                </h4>
                                <Row className="w-100 ms-0">
                                    <Col md={12}>
                                        <Form.Group
                                            className="mb-3 position-relative focus-z-index mt-3 d-flex flex-column"
                                            controlId="formAddress"
                                        >
                                            <Form.Label
                                                style={{ marginBottom: "2px", marginTop: "2px" }}
                                            >
                                                Address
                                            </Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    as={"textarea"}
                                                    {...register("address")}
                                                ></Form.Control>
                                            </InputGroup>
                                            {errors.address && (
                                                <p
                                                    style={{ fontSize: "12px" }}
                                                    className="text-danger mt-1"
                                                >
                                                    {errors.address.message}
                                                </p>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group
                                            className="mb-3 position-relative d-flex flex-column focus-z-index"
                                            controlId="formCountry"
                                        >
                                            <Form.Label
                                                style={{ marginBottom: "2px", marginTop: "2px" }}
                                            >
                                                Select Country
                                            </Form.Label>
                                            <Select
                                                options={[
                                                    { value: "99", label: "India" },
                                                    ...country?.map((c) => ({
                                                        value: c.countryId,
                                                        label: c.countryName,
                                                    })),
                                                ]}
                                                value={
                                                    watch("countryId")
                                                        ? {
                                                            value: watch("countryId"),
                                                            label:
                                                                country.find(
                                                                    (c) =>
                                                                        c.countryId === watch("countryId")
                                                                )?.countryName || "India",
                                                        }
                                                        : { value: "99", label: "India" }
                                                }
                                                onChange={(selectedOption) => {
                                                    const newValue = selectedOption
                                                        ? selectedOption.value
                                                        : "99"
                                                    setValue("countryId", newValue)
                                                    setValue("state", "")
                                                    setValue("city", "")
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                classNamePrefix="react-select"
                                                styles={customStyles}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group
                                            className="mb-3 d-flex flex-column position-relative focus-z-index"
                                            controlId="formState"
                                        >
                                            <Form.Label
                                                style={{ marginBottom: "2px", marginTop: "2px" }}
                                            >
                                                Select State
                                            </Form.Label>
                                            <Controller
                                                name="state"
                                                control={control}
                                                rules={{ required: "State is Required" }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <>
                                                        <Select
                                                            styles={customStyles}
                                                            {...field}
                                                            options={states?.map((state) => ({
                                                                value: state.stateCode,
                                                                label: state.stateName,
                                                            }))}
                                                            value={
                                                                states.find(
                                                                    (s) => s.stateCode === field.value
                                                                )
                                                                    ? {
                                                                        value: field.value,
                                                                        label:
                                                                            states.find(
                                                                                (s) => s.stateCode === field.value
                                                                            )?.stateName || "",
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(selectedOption) => {
                                                                field.onChange(selectedOption?.value || "")
                                                                setValue("city", "")
                                                            }}
                                                            isSearchable
                                                            isClearable
                                                            placeholder="Select State"
                                                            classNamePrefix="react-select"
                                                            noOptionsMessage={() => "No states available"}
                                                        />
                                                        {error && (
                                                            <p
                                                                style={{ fontSize: "12px" }}
                                                                className="text-danger mt-1"
                                                            >
                                                                {error.message}
                                                            </p>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group
                                            className="mb-3 position-relative d-flex flex-column focus-z-index"
                                            controlId="formCity"
                                        >
                                            <Form.Label
                                                style={{ marginBottom: "2px", marginTop: "2px" }}
                                            >
                                                Select City
                                            </Form.Label>
                                            <Controller
                                                name="city"
                                                control={control}
                                                rules={{ required: "City is Required" }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <>
                                                        <Select
                                                            // styles={customStylesForCIty}
                                                            styles={customStyles}
                                                            {...field}
                                                            options={city?.map((c) => ({
                                                                value: c.cityCode,
                                                                label: c.cityName,
                                                            }))}
                                                            value={
                                                                city.find((c) => c.cityCode === field.value)
                                                                    ? {
                                                                        value: field.value,
                                                                        label:
                                                                            city.find(
                                                                                (c) => c.cityCode === field.value
                                                                            )?.cityName || "",
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(selectedOption) => {
                                                                field.onChange(selectedOption?.value || "")
                                                            }}
                                                            isSearchable
                                                            isClearable
                                                            placeholder="Select City"
                                                            noOptionsMessage={() => "No cities available"}
                                                            classNamePrefix={"react-select"}
                                                        />
                                                        {error && (
                                                            <p
                                                                style={{ fontSize: "12px" }}
                                                                className="text-danger mt-1"
                                                            >
                                                                {error.message}
                                                            </p>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group
                                            className="mb-3 position-relative d-flex flex-column focus-z-index"
                                            controlId="formZipcode"
                                        >
                                            <Form.Label
                                                style={{ marginBottom: "2px", marginTop: "2px" }}
                                            >
                                                Enter Zipcode
                                            </Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    {...register("zipcode", {
                                                        required: true,
                                                        setValueAs: (value) => value.trim(),
                                                    })}
                                                    placeholder="Enter Zipcode"
                                                />
                                            </InputGroup>
                                            {errors.zipcode && (
                                                <p
                                                    style={{ fontSize: "12px" }}
                                                    className="text-danger mt-1"
                                                >
                                                    {errors.zipcode.message}
                                                </p>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                        </>}

                        {/* social links */}
                        {!showRequired && <>
                            <hr />
                            <div className="offcanvasSections">
                                <h4 id="Social" className="offcanvasSecHeading">
                                    Social
                                </h4>
                                <Row className="w-100 ms-0 mt-3">
                                    <Col md={6}>
                                        <Form.Group
                                            className="mb-3 position-relative focus-z-index"
                                            controlId="formFacebook"
                                        >
                                            <Form.Label>Facebook</Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    {...register("facebook")}
                                                    placeholder="Enter URL"
                                                />
                                            </InputGroup>
                                            {errors.facebook && (
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    {errors.facebook.message}
                                                </span>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group
                                            className="mb-3 position-relative focus-z-index"
                                            controlId="formLinkedin"
                                        >
                                            <Form.Label>
                                                Linkedin
                                            </Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    {...register("linkedin")}
                                                    placeholder="Enter URL"
                                                />
                                            </InputGroup>
                                            {errors.linkedin && (
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    {errors.linkedin.message}
                                                </span>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group
                                            className="mb-3 position-relative focus-z-index"
                                            controlId="formInstagram"
                                        >
                                            <Form.Label>Instagram </Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    {...register("instagram")}
                                                    placeholder="Enter URL"
                                                />
                                            </InputGroup>
                                            {errors.instagram && (
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    {errors.instagram.message}
                                                </span>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group
                                            className="mb-3 position-relative focus-z-index"
                                            controlId="formTwitter"
                                        >
                                            <Form.Label>Twitter </Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    {...register("twitter")}
                                                    placeholder="Enter URL"
                                                />
                                            </InputGroup>
                                            {errors.twitter && (
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    {errors.twitter.message}
                                                </span>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                        </>}

                        {/* professional info */}
                        {
                            !showRequired &&
                            <>
                                <hr />
                                <div className="offcanvasSections">
                                    <h4 id="Professional" className="offcanvasSecHeading">
                                        Professional
                                    </h4>
                                    <Row className="w-100 ms-0 mt-3">

                                        <Col md={6}>
                                            <div>
                                                <Form.Group
                                                    className="mb-3 position-relative d-flex flex-column focus-z-index"
                                                    controlId="formCompany"
                                                    style={{ position: "relative" }}
                                                >
                                                    <Form.Label
                                                        style={{ marginBottom: "2px", marginTop: "2px" }}
                                                    >
                                                        Company
                                                    </Form.Label>
                                                    <Controller
                                                        name="company_id"
                                                        control={control}
                                                        render={({ field, fieldState: { error } }) => (
                                                            <>
                                                                <Select
                                                                    {...field}
                                                                    className="input-box-select"
                                                                    options={[
                                                                        ...company?.map((c) => ({
                                                                            value: c.company_id,
                                                                            label: c.company_name,
                                                                        })),
                                                                    ]}
                                                                    value={
                                                                        company.find(
                                                                            (c) => c.company_id === field.value
                                                                        )
                                                                            ? {
                                                                                value: field.value,
                                                                                label: company.find(
                                                                                    (c) => c.company_id === field.value
                                                                                )?.company_name,
                                                                            }
                                                                            : null
                                                                    }
                                                                    onChange={(selectedOption) => {
                                                                        if (selectedOption?.value == "add_new") {
                                                                            setCompanyShow(!companyShow)
                                                                        } else {
                                                                            field.onChange(
                                                                                selectedOption?.value || ""
                                                                            )
                                                                        }
                                                                    }}
                                                                    isClearable={true}
                                                                    isSearchable={true}
                                                                    placeholder="Select"
                                                                    components={{
                                                                        Option: CustomOption1,
                                                                        MenuList,
                                                                    }}
                                                                    module={"Company"}
                                                                    onAddNew={() => {
                                                                        setCompanyShow(!companyShow)
                                                                        setShow(false)
                                                                    }}
                                                                    classNamePrefix="react-select"
                                                                    styles={customStyles}
                                                                    moduleType={"company"}
                                                                    canCreate={companyGrants?.isCreate}
                                                                />
                                                                {error && (
                                                                    <p
                                                                        style={{ fontSize: "12px" }}
                                                                        className="text-danger mt-1"
                                                                    >
                                                                        {error.message}
                                                                    </p>
                                                                )}
                                                            </>
                                                        )}
                                                    />
                                                </Form.Group>
                                            </div>
                                        </Col>
                                        <>
                                            <Col md={6}>
                                                <Form.Group
                                                    className="mb-3 position-relative focus-z-index"
                                                    controlId="formDepartment"
                                                >
                                                    <Form.Label>
                                                        Department
                                                    </Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            {...register("department")}
                                                            placeholder="Enter Department"
                                                        />
                                                    </InputGroup>
                                                    {errors.department && (
                                                        <p
                                                            style={{ fontSize: "12px" }}
                                                            className="text-danger mt-1 "
                                                        >
                                                            {errors.department.message}
                                                        </p>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group
                                                    className="mb-3 position-relative focus-z-index"
                                                    controlId="formDesignation"
                                                >
                                                    <Form.Label>
                                                        Designation
                                                    </Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="text"
                                                            {...register("designation")}
                                                            placeholder="Enter Designation"
                                                        />
                                                    </InputGroup>
                                                    {errors.designation && (
                                                        <p
                                                            style={{ fontSize: "12px" }}
                                                            className="text-danger mt-1 "
                                                        >
                                                            {errors.designation.message}
                                                        </p>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <div className="d-flex gap-2 h-100 align-items-center">
                                                    <button
                                                        type="button"
                                                        onClick={() => setDecision(!decision)}
                                                        style={{
                                                            width: "35px",
                                                            height: "19px",
                                                            borderRadius: "20px",
                                                            backgroundColor: decision ? "#7a3a5e" : "#c9c9c9",
                                                            cursor: "pointer",
                                                            padding: "3px",
                                                            position: "relative",
                                                            transition: "background-color 0.3s ease",
                                                            border: "1px solid #a69e9e",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: "12px",
                                                                height: "12px",
                                                                borderRadius: "50%",
                                                                backgroundColor: "white",
                                                                position: "absolute",
                                                                left: decision ? "calc(100% - 17px)" : "2px",
                                                                top: "2px",
                                                                transition: "left 0.3s ease",
                                                                boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                                                            }}
                                                        ></div>
                                                    </button>
                                                    <p
                                                        className="text-secondary mb-0"
                                                        style={{ fontSize: "14px" }}
                                                    >
                                                        Decision Maker
                                                    </p>
                                                </div>
                                            </Col>
                                        </>
                                    </Row>
                                </div>
                            </>
                        }
                        <hr />
                        {/* Campaign Information */}
                        <div className="offcanvasSections">
                            <h4 id="CampaignInformation" className="offcanvasSecHeading">
                                Campaign Information
                            </h4>
                            <Row className="w-100 ms-0 mt-3">
                                <Col md={6}>
                                    <div ref={leadSourceRef}>
                                        <Form.Group
                                            className="mb-3 d-flex flex-column focus-z-index position-relative"
                                            controlId="formLeadSource"
                                        >
                                            <Form.Label style={{ marginTop: "2px" }}>
                                                Lead Source <span className="text-danger">*</span>
                                            </Form.Label>

                                            <Controller
                                                name="lead_source_id"
                                                control={control}
                                                rules={{ required: "Lead Source is Required" }}
                                                render={({ field, fieldState: { error } }) => (
                                                    <>
                                                        <Select
                                                            styles={customStyles}
                                                            {...field}
                                                            className="input-box-select"
                                                            options={[
                                                                ...lead_source?.map((lead) => ({
                                                                    value: lead.lead_source_id,
                                                                    label: lead.source_title,
                                                                })),
                                                            ]}
                                                            value={
                                                                lead_source.find(
                                                                    (lead) =>
                                                                        lead.lead_source_id === field.value
                                                                )
                                                                    ? {
                                                                        value: field.value,
                                                                        label: lead_source.find(
                                                                            (lead) =>
                                                                                lead.lead_source_id ===
                                                                                field.value
                                                                        )?.source_title,
                                                                    }
                                                                    : null
                                                            }
                                                            onChange={(selectedOption) => {
                                                                if (selectedOption?.value === "add_new") {
                                                                    setSourceShow(!sourceShow)
                                                                } else {
                                                                    field.onChange(
                                                                        selectedOption?.value || ""
                                                                    )
                                                                }
                                                            }}
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            placeholder="Select"
                                                            classNamePrefix="react-select"
                                                            components={{
                                                                MenuList,
                                                            }}
                                                            onAddNew={() => setSourceShow(!sourceShow)}
                                                            module={"Lead Source"}
                                                            moduleType={"lead_source"}
                                                            canCreate={masterGrant?.isCreate}
                                                        />
                                                        {error && (
                                                            <p
                                                                style={{ fontSize: "12px" }}
                                                                className="text-danger mt-1"
                                                            >
                                                                {error.message}
                                                            </p>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                </Col>

                                {!showRequired && <>
                                    <Col md={12}>
                                        <Form.Group
                                            className="mb-3 position-relative d-flex flex-column focus-z-index"
                                            controlId="formTags"
                                        >
                                            <Form.Label
                                                style={{ marginBottom: "2px", marginTop: "2px" }}
                                            >
                                                Tags
                                            </Form.Label>
                                            <div
                                                style={{
                                                    border: "1px solid #e1d5db",
                                                    borderRadius: "5px",
                                                    minHeight: "38px",
                                                    display: "flex",
                                                    justifyItems: "center",
                                                    padding: "3px",
                                                    background: "#fff",
                                                }}
                                            >
                                                <TagsInput
                                                    value={tags}
                                                    className="rounded-1 custom"
                                                    onChange={handleTagChange}
                                                    inputProps={{
                                                        placeholder: "Press enter to add."
                                                    }}
                                                />
                                                <style>
                                                    {`
                                                            .react-tagsinput-tag {
                                                                background-color : #1770ff !important;
                                                                color : white;
                                                            }
                                                            .react-tagsinput-remove{
                                                                color : white;
                                                            }
                                                            .react-tagsinput-input{
                                                                width : 176px;
                                                                padding: 0rem 0rem 0rem !important;
                                                            }
                                                            .custom{
                                                                padding-left : 0.5rem;
                                                                margin-top : 9px;
                                                            }
                                                        `}
                                                </style>
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={12}>
                                        <Form.Group
                                            className="mb-3 position-relative d-flex flex-column focus-z-index"
                                            controlId="formNotes"
                                        >
                                            <Form.Label
                                                style={{ marginBottom: "2px", marginTop: "2px" }}
                                            >
                                                Notes
                                            </Form.Label>
                                            <InputGroup>
                                                <Form.Control
                                                    as={"textarea"}
                                                    {...register("note")}
                                                ></Form.Control>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </>}
                            </Row>
                        </div>

                        {/* grouped custom fields */}
                        {grouped &&
                            grouped.length !== 0 &&
                            grouped?.map((g) => {
                                const capitalizedName = g.group_name.replace(
                                    /\b\w/g,
                                    (char) => char.toUpperCase()
                                )

                                const filteredGroupFields =
                                    g.groupFields?.filter(shouldShowField) || [];


                                if (
                                    filteredGroupFields.length === 0 &&
                                    showRequired
                                ) {
                                    return null;
                                }
                                return (
                                    <React.Fragment key={g.id}>
                                        {filteredGroupFields.length !== 0 && <hr />}

                                        <div className="offcanvasSections">
                                            <h4
                                                id={capitalizedName}
                                                className="offcanvasSecHeading"
                                            >
                                                {filteredGroupFields.length !== 0 && capitalizedName}
                                            </h4>
                                            <Row className="w-100 ms-0 mt-3">
                                                {filteredGroupFields.length !== 0 &&
                                                    filteredGroupFields?.map((field) => {
                                                        return (
                                                            <React.Fragment key={field.id}>
                                                                {
                                                                    field.label_type === "text" && (
                                                                        <Col md={6}>
                                                                            <Text
                                                                                name={field.id}
                                                                                label_name={field.label_name}
                                                                                label_type={field.label_type}
                                                                                control={control}
                                                                                rules={{
                                                                                    required: `${field.label_name} is required`,
                                                                                }}
                                                                                isRequired={field.is_required === "yes"}
                                                                                isImportant={field.is_important === "yes"}
                                                                            />
                                                                        </Col>
                                                                    )
                                                                }

                                                                {
                                                                    field.label_type === "monetary" && (
                                                                        <Col md={6}>
                                                                            <Text
                                                                                name={field.id}
                                                                                label_name={field.label_name}
                                                                                label_type={field.label_type}
                                                                                control={control}
                                                                                rules={{
                                                                                    required: `${field.label_name} is required`,
                                                                                }}
                                                                                isRequired={
                                                                                    field.is_required === "yes"
                                                                                }
                                                                                isImportant={
                                                                                    field.is_important === "yes"
                                                                                }
                                                                            />
                                                                        </Col>
                                                                    )}

                                                                {field.label_type === "largeText" && (
                                                                    <Col md={6}>
                                                                        <Text
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            rules={{
                                                                                required: `${field.label_name} is required`,
                                                                            }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={
                                                                                field.is_important === "yes"
                                                                            }
                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "numerical" && (
                                                                    <Col md={6}>
                                                                        <Text
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            rules={{
                                                                                required: `${field.label_name} is required`,
                                                                            }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={
                                                                                field.is_important === "yes"
                                                                            }
                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "address" && (
                                                                    <Col md={6}>
                                                                        <Text
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            rules={{
                                                                                required: `${field.label_name} is required`,
                                                                            }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={
                                                                                field.is_important === "yes"
                                                                            }
                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "single-option" && (
                                                                    <Col md={6}>
                                                                        <SelectOpt
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            rules={{
                                                                                required: `${field.label_name} is required`,
                                                                            }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={
                                                                                field.is_important === "yes"
                                                                            }
                                                                            options={
                                                                                field.option !== null &&
                                                                                field.option
                                                                            }
                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "user" && (
                                                                    <Col md={6}>
                                                                        <SelectOpt
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            rules={{
                                                                                required: `${field.label_name} is required`,
                                                                            }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={
                                                                                field.is_important === "yes"
                                                                            }
                                                                            options={leadOwner}
                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "person" && (
                                                                    <Col md={6}>
                                                                        <SelectOpt
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            rules={{
                                                                                required: `${field.label_name} is required`,
                                                                            }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={
                                                                                field.is_important === "yes"
                                                                            }
                                                                            options={
                                                                                allContacts.length > 0
                                                                                    ? allContacts
                                                                                    : []
                                                                            }
                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "organization" && (
                                                                    <Col md={6}>
                                                                        <SelectOpt
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            rules={{
                                                                                required: `${field.label_name} is required`,
                                                                            }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={
                                                                                field.is_important === "yes"
                                                                            }
                                                                            options={company}
                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "time" && (
                                                                    <Col md={6}>
                                                                        <Time
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={
                                                                                field.is_important === "yes"
                                                                            }
                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "time-range" && (
                                                                    <Col md={6}>
                                                                        <Time
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            // rules={{
                                                                            //   required:
                                                                            //     // field.is_required === "yes" 
                                                                            //     // &&  "Working hours are required",
                                                                            //     `${field.label_name} is required`
                                                                            // }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={
                                                                                field.is_important === "yes"
                                                                            }
                                                                        />
                                                                    </Col>
                                                                )}

                                                                {field.label_type === "phone" && (
                                                                    <Col md={6}>
                                                                        <PhoneNumberInput
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            rules={{
                                                                                required:
                                                                                    field.is_required === "yes" &&
                                                                                    "Phone number is required",
                                                                            }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            validatePhoneNumber={
                                                                                validatePhoneNumber
                                                                            }
                                                                            isImportant={field.is_important === "yes"}

                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "date" && (
                                                                    <Col md={6}>
                                                                        <DateField
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            rules={{
                                                                                required:
                                                                                    field.is_required === "yes" &&
                                                                                    "Date is required",
                                                                            }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={field.is_important === "yes"}

                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "date range" && (
                                                                    <Col md={6}>
                                                                        <DateField
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            rules={{
                                                                                required:
                                                                                    field.is_required === "yes" &&
                                                                                    "Date Range number is required",
                                                                                validate: {
                                                                                    validRange: (value) => {
                                                                                        if (
                                                                                            !value?.start ||
                                                                                            !value?.end
                                                                                        )
                                                                                            return true
                                                                                        return (
                                                                                            value.start <= value.end ||
                                                                                            "End date must be after or same as start date"
                                                                                        )
                                                                                    },
                                                                                },
                                                                            }}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                            }
                                                                            isImportant={field.is_important === "yes"}

                                                                        />
                                                                    </Col>
                                                                )}
                                                                {field.label_type === "multiple-option" && (
                                                                    <Col md={6}>
                                                                        <MultipleOpt
                                                                            name={field.id}
                                                                            label_name={field.label_name}
                                                                            label_type={field.label_type}
                                                                            control={control}
                                                                            isRequired={
                                                                                field.is_required === "yes"
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            isImportant={
                                                                                field.is_important === "yes"
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            options={
                                                                                field.option &&
                                                                                JSON.parse(field.option)
                                                                            }
                                                                            rules={{
                                                                                required:
                                                                                    field.is_required === "yes" &&
                                                                                    "Teams is required",
                                                                            }}
                                                                        />
                                                                    </Col>
                                                                )}
                                                            </React.Fragment>
                                                        )
                                                    })}
                                            </Row>
                                        </div>
                                    </React.Fragment>
                                )
                            })}

                        {/* ungrouped custom fields */}
                        {ungrouped?.length !== 0 && <hr />}
                        <Row
                            className="w-100 ms-0 mt-3"
                            style={{ paddingLeft: "20px" }}
                        >
                            {ungrouped &&
                                ungrouped.length !== 0 &&
                                ungrouped.filter(shouldShowField)?.map((field) => {
                                    return (
                                        <React.Fragment key={field.id}>
                                            {field.label_type === "text" && (
                                                <Col md={6}>
                                                    <Text
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required: `${field.label_name} is required`,
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "monetary" && (
                                                <Col md={6}>
                                                    <Text
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required: `${field.label_name} is required`,
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "largeText" && (
                                                <Col md={6}>
                                                    <Text
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required: `${field.label_name} is required`,
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "numerical" && (
                                                <Col md={6}>
                                                    <Text
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required: `${field.label_name} is required`,
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "address" && (
                                                <Col md={6}>
                                                    <Text
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required: `${field.label_name} is required`,
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "single-option" && (
                                                <Col md={6}>
                                                    <SelectOpt
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required: `${field.label_name} is required`,
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                        options={field.option !== null && field.option}
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "user" && (
                                                <Col md={6}>
                                                    <SelectOpt
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required: `${field.label_name} is required`,
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                        options={leadOwner}
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "person" && (
                                                <Col md={6}>
                                                    <SelectOpt
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required: `${field.label_name} is required`,
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                        options={
                                                            allContacts.length > 0 ? allContacts : []
                                                        }
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "organization" && (
                                                <Col md={6}>
                                                    <SelectOpt
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required: `${field.label_name} is required`,
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                        options={company}
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "time" && (
                                                <Col md={6}>
                                                    <Time
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}

                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "time-range" && (
                                                <Col md={6}>
                                                    <Time
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        // rules={{
                                                        //   required:
                                                        //     field.is_required === "yes" &&
                                                        //     "Working hours are required",
                                                        //   validate: {
                                                        //     validRange: (value) => {
                                                        //       if (!value?.start || !value?.end)
                                                        //         return true
                                                        //       return (
                                                        //         value.start < value.end ||
                                                        //         "End time must be after start time"
                                                        //       )
                                                        //     },
                                                        //   },
                                                        // }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                    />
                                                </Col>
                                            )}

                                            {field.label_type === "phone" && (
                                                <Col md={6}>
                                                    <PhoneNumberInput
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required:
                                                                field.is_required === "yes" &&
                                                                "Phone number is required",
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        validatePhoneNumber={validatePhoneNumber}
                                                        isImportant={field.is_important === "yes"}
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "date" && (
                                                <Col md={6}>
                                                    <DateField
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        rules={{
                                                            required:
                                                                field.is_required === "yes" &&
                                                                "Date is required",
                                                        }}
                                                        isRequired={field.is_required === "yes"}
                                                        isImportant={field.is_important === "yes"}
                                                    />
                                                </Col>
                                            )}
                                            {field.label_type === "date range" && (
                                                <Col md={6}>
                                                    <DateField
                                                        name={field.id}
                                                        label_name={field.label_name}
                                                        label_type={field.label_type}
                                                        control={control}
                                                        // rules={{
                                                        //   required:
                                                        //     field.is_required === "yes" &&
                                                        //     "Date Range number is required",
                                                        //   validate: {
                                                        //     validRange: (value) => {
                                                        //       if (!value?.start || !value?.end)
                                                        //         return true
                                                        //       return (
                                                        //         value.start <= value.end ||
                                                        //         "End date must be after or same as start date"
                                                        //       )
                                                        //     },
                                                        //   },
                                                        // }}
                                                        isImportant={field.is_important === "yes"}
                                                        isRequired={field.is_required === "yes"}
                                                    />
                                                </Col>
                                            )}
                                        </React.Fragment>
                                    )
                                })}
                        </Row>
                        <div style={{ height: "80px" }}></div>

                        {/* save and cancel button */}
                        <div
                            style={{
                                position: "fixed",
                                width: "60%",
                                bottom: 0,
                                height: "74px",
                                zIndex: 2,
                                right: 0,
                                background: "#fefefe",
                                paddingRight: "20px",
                                borderTop: "1px solid #c4ebf7",
                            }}
                        >
                            <div className="d-flex justify-content-end gap-2 pt-4">
                                <Button
                                    onClick={handleClose}
                                    className="btn btn-default-outline"
                                    variant="custom-variant"
                                    style={{ border: "1px solid black", width: "90px" }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    className="btn btn-default btn-primary"
                                    variant="action-btn"
                                    style={{ width: "90px" }}
                                >
                                    Save
                                </Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}
